const book1Pages = [
    {
      pageNumber: "001",
      heading: "FiRST DECENT iNTO LiGHT",
      subtitle: "Early Life Poems Written By Casey Crossman From NEP2YN",
      body: `“Meaning flowing out of you , as you .”
`,
    },
  
    {
      pageNumber: "002",
      heading: "BAMN PREFACE",
      body: `SECTiON I - CHAOS , LiGHT , CREATiON

SECTiON II - KNiGHTS , CASTLES , CODES 

SECTiON III - DANCE , THEATER , LiGHT / DARK 

SECTiON IV - METAMORPHOSiS , FAMiLY , EMOTION
`,
    },
    {
        pageNumber: "003",
        heading: "SECTiON I - CHAOS , LiGHT , CREATiON",
      },
      {
        pageNumber: "004",
        subtitle: "SECTION I",
        body: `i watch the lifespan of a star . 
i watch the lifespan of a flower . 
i see eternity in both . 
their life created change simply by existing . 
to the star , the flower was here one minute , and gone the next . 
the flower lived every second with the star . they both happened , forever .`,
      },
      {
        pageNumber: "005",
        subtitle: "SECTION I",
        body: `does meditation require peace or does peace require meditation ? 
        i've found that conscious action is what delivers not only peace , 
        but also joy and fulfillment .`,
      },
      {
        pageNumber: "006",
        subtitle: "SECTION I",
        body: `this life has no meaning at all . 
there’s no point to anything . 
it’s all chaos .

still , i feel obligated to create meaning for myself .  
i find through alchemy of my own joy i seem to inspire fun and direction for others . 

on the other hand i witness a reminder of life’s brutality . 
watching loved ones stumble , under achieve , make mistakes , expire . all on their first and only try . 
it is all fate in our crossroads . 

i realize this story isn’t mine alone . 
it’s happening , has happened , in countless other families , unseen . 
this scares me and makes me question the intention in the creation of this world . 
was there any intention ? 
complexity of these organic structures whispers toward some intelligent design , but yet again chaos screams back . 
who am i to question architecture as a creation myself , i wasn’t there to witness the final measurements of this reality . 

nevertheless , 
a scary world of suffering . 
beautiful world of lessons , individuality , and evolution . 
maybe this dynamic is enough meaning for me .
if this is as far as i’ll get , then i’ll consider this enlightenment , and begin singing as an instrument myself .`,
      },
      {
        pageNumber: "007",
        subtitle: "SECTION I",
        body: `the dialogue between me and my creator goes “ make me new today ” , 
        and time passes . 
        i experience a revelation , 
        and ask if this is really the idea in store for me at the conception of my initial request . 
        the immediate response is why question the feelings intended target if it’s teaching . 
        the truth is in the learning . `,
      },
      {
        pageNumber: "008",
        subtitle: "SECTION I",
        body: `this moment rewards in eternity .`,
      },
      {
        pageNumber: "009",
        subtitle: "SECTION I",
        body: `i sometimes think of afterlife as everything ever on record , 
in a database , 
able to be revisited . 
i close my eyes ,
and i see heavenly wisps of light .
what angel is speaking that light into only my eye ? 
is that moment recorded as well ? 
what is the extent of the database ? 
how could every thread of light sung into existence , 
and simultaneously , chaotically being created across this whole plane of existence , 
possibly be catalogued by some master custodian of the index ? 
what library of that scale requires what kind of grand archivist ? 
the one who just knows where everything is , 
or the one who recalls each book every day for writing new stories ,
and new projects utilizing these presets ? 
that is the kind of insanity of a creator i sometimes feel like i'm becoming . 
if afterlife is less about memory , 
and more creation ,
then maybe afterlife is the release of this insanity , 
and the adoption of creating purely for the moment .
singing light into now because it feels good , 
and because i'll be able to do it again in a second without the burden of revisiting that expression , 
and alchemizing it further into 4 bars , 
onto a canvas ,
through fabrics as a thread and needle . 
maybe it's about submitting to the chaos of life , and creation .`,
      },
      {
        pageNumber: "010",
        subtitle: "SECTION I",
        body: `when i die the world will be a better place . 
        my next role will be greater than anything i can do now , 
        but continuing that same mission . 
        until then i continue this journey , 
        and spread my physical presence across of all regions . 
        i continue to spread this spirit of love a cross of all hearts .`,
      },
      {
        pageNumber: "011",
        subtitle: "SECTION I",
        body: `be conscious right now. 
        change something in this day to have a better tomorrow. 
        this is the one opportunity .`,
      },
      {
        pageNumber: "012",
        subtitle: "SECTION I",
        body: `if there is an eternal reward waiting , 
i'm positive it will be measured by the time i spent 
walking , with my legs , 
building , with my hands , 
speaking , with my tongue , 
admiring , with my eyes , 
and inspiring , with my actions . 
not by the time i spent waiting in faith , 
or the discouragement of others' journey , 
or in tradition built for those who are lost , 
or the shunning from the voice of God in the divine breathed moment of right now just because i liked how he sounded in the book more .
this concept reward will measure my choices from action ,
learning trom examples , 
stepping on my own path ,
and touching those to be better on their way , and listening to the inspiration of now .`,
      },
      {
        pageNumber: "013",
        subtitle: "SECTION I",
        body: `the life we experience together requires no edits .
everything is aligned perfectly in chaos .`,
      },
      {
        pageNumber: "014",
        subtitle: "SECTION I",
        body: `a perfect structure built by sick people will block only what’s normal, and what normally manifests for your evolution .

those who did such horrible acts may not get what they deserve , but what they created was what the world needed only by unnatural means .

what kind of light radiates from a sick person , and how does it differ from christ ?`,
      },
      {
        pageNumber: "015",
        heading: "SECTiON II - KNiGHTS , CASTLES , CODES",
      },
      {
        pageNumber: "016",
        subtitle: "SECTION II",
        body: `the unknown knight grows stronger over the hill . 
        restless with ideas . 
        every waking moment is a moment to evolve . 
        the land has never felt this much harmony . 
        the castle has never protected this much life .`,
      },
      {
        pageNumber: "017",
        subtitle: "SECTION II",
        body: `i didn't run away because my village failed me . 
        i deem everything contributes to my evolution . 
        so i've never held resentment . 
        i am simply practicing liberation . 
        so i've never held resentment . 
        i continue my practices in all environments , 
        but it seems the environment i've been searching for , 
        most beneficial to me , 
        lies in life so vocal to accept this light . 
        i wish this life so vocal to affirm its inspiration ceases region .`,
      },
      {
        pageNumber: "018",
        subtitle: "SECTION II",
        body: `if i created a world. if i ruled a castle .
if it was my responsibility to instill meaning and passion into those .
i would lead with this set of principles .

   1. build for contribution, not domination.
   2. add to the story of our world .
   3. let conflict be ritual, never random.
   4. do not steal, nor destroy the creation of another.
   5. leave every life and land better than you found it .
   6. bring wonder and entertainment to all living things around you .
   7. when inspiration visits, sunborn or moonlit, embody it, and walk the path it reveals.
   8. record what you create or discover, so that memory may inspire our brothers and sisters, our children, and our children's children
   9. honor and learn from each being . let every soul cast its light or shadow, and define its own shape, name, and destiny .
   10. seek discovery and evolution, approach mystery with curiosity, not fear . 

by these principles a world is shaped . 
our world is made . 
not through force , but creation . 
not through fear, but wonder .
not in shadow , nor in light alone .
but in the organic art of living .
live only by rules to prosper your world . 
don't expect guidelines given to you by another individual to resonate with your soul , 
or evolve your self . 
use discernment to create this way of life . 
don't ignore any harmful or beneficial aspects . `,
      },
      {
        pageNumber: "019",
        subtitle: "SECTION II",
        body: `my first time in battle i saw real sword fighting . 
        not the kind i was used to seeing in a play . 
        no theatrical movements . 
        they both were trying to kill each other with their blades . 
        i saw panic as they spent their energy more depleted with every swing they gave all strength towards . 
        i saw acceptance of the inevitable doom on the face of the man with only one hand left . 
        i saw the short end of the straw being held by the man feeling a sword go through his heart . 
        all this suffering came to be from a man crucified for his beliefs . 
        my internal desire isn’t strong enough to join this battle simply because i want to kill those who believe that man’s teachings .`,
      },
      {
        pageNumber: "020",
        subtitle: "SECTION II",
        body: `how am i meeting you now ? 
        i have walked every path , 
        swam every current , 
        climbed every tree , 
        slept on every cloud , 
        felt every rain drop , 
        memorized every snowflake , 
        held every lightning bolt , 
        ate every fruit , 
        befriended all life , 
        and this is my first time seeing you here . 
        my immortality is lonely , 
        but i feel like this will be fun for as long as you're alive . 
        i'll consider this our first date .`,
      },
      {
        pageNumber: "021",
        subtitle: "SECTION II",
        body: `i've always wanted to be used as the greatest tool , 
        played as the greatest instrument , 
        flown with the greatest wings , 
        and inspire as the greatest example .`,
      },
      {
        pageNumber: "022",
        subtitle: "SECTION II",
        body: `care less about perception . 
        do more what you wish . 
        greater things await in any direction of action and visions .`,
      },
      {
        pageNumber: "023",
        subtitle: "SECTION II",
        body: `do what you would like to see yourself doing .`,
      },
      {
        pageNumber: "024",
        subtitle: "SECTION II",
        body: `with every path available ; 
        step over the fence and walk your own . 
        one step in an attractive direction leads to a second desired step .`,
      },
      {
        pageNumber: "025",
        subtitle: "SECTION II",
        body: `make yourself known . 
        speak through inspired action . `,
      },
      {
        pageNumber: "026",
        subtitle: "SECTION II",
        body: `let every step i take root to the bottom of this realm , 
        to grow new life , 
        forever , 
        even when the tree withers . `,
      },
      {
        pageNumber: "027",
        subtitle: "SECTION II",
        body: `step to leave more than footprint . 
        plant roots with each action so your tree grows in your intentions image . `,
      },
      {
        pageNumber: "028",
        subtitle: "SECTION II",
        body: `if every intentional action plants new roots , 
        what would that tree look like ? 
        would the roots grow to trip those on their own journey , 
        or become stairs to reach new heights . 
        grow thorns to hurt those seeking refuge , 
        or provide shade on a hot day .`,
      },
      {
        pageNumber: "029",
        subtitle: "SECTION II",
        body: `i chase a door . 
light shining through the door .
there’s nothing behind the door .
but i met you at that door .`,
      },
      {
        pageNumber: "030",
        subtitle: "SECTION II",
        body: `i choose solitude because i want it . 
        this journey has taken me so far out . 
        you will never find me . 
        physically , to you , i no longer exist . 
this state of being enables me to create from deeper than ever , 
express from deeper than ever , 
to feel deeper than ever , 
and in turn creates our deepest intimacy .`,
      },
      {
        pageNumber: "031",
        subtitle: "SECTION II",
        body: `how are we supposed to communicate in life after death . 
        are we doing it right now ? 
        is what i'm seeing now also a moment to be observed when i am formless ? 
        what does the transition from the organic to spirit look like , 
        feel like ? 
        i'm trained for battle , 
        but i've never killed anyone . 
        i'm afraid if i have to , i'll envy their walk over that celestial bridge , 
        and wonder once more what they are seeing .`,
      },
      {
        pageNumber: "032",
        subtitle: "SECTION II",
        body: `as a mortal , create , don’t memorize .`,
      },
      {
        pageNumber: "033",
        subtitle: "SECTION II",
        body: `i heard sounds i’ve never heard .
i felt spirits i’ve never felt inflict mental trials .
I fought away patterns , 
and that exists all the time , but i will go into town now  .`,
      },
      {
        pageNumber: "034",
        subtitle: "SECTION II",
        body: `break free from depressive thought patterns . 
        find the peak in your existence and excitement where your spirit lives , 
        and realize you can always live there .`,
      },
      {
        pageNumber: "035",
        subtitle: "SECTION II",
        body: `i think people with the strongest feelings about me are the ones who are closest to becoming me. 
        let’s say i looked like an alien, 
        or a beast, 
        and did the things i do. 
        maybe people would expect nothing less of my actions. 
        the people with similar looks, build, skin, hair, even upbringing as me are the ones with the strongest feelings. 
        either feelings of the strongest repulsion or the strongest attraction. 
        maybe its easiest for them to picture themselves in my boots, 
        on my journey, 
        with my voice, 
        in my ways .`,
      },
      {
        pageNumber: "036",
        subtitle: "SECTION II",
        body: `climb to the peak of your 
existence ,
and excitement .
find where your spirit truly lives ,
and realize you can always live there .`,
      },
      {
        pageNumber: "037",
        subtitle: "SECTION II",
        body: `moving fast but i’m still .`,
      },
      {
        pageNumber: "038",
        subtitle: "SECTION II",
        body: `this is it .
the one opportunity to enjoy the experience of time .
once the life in me is drained , i’m gone .
time is running out to live in joy .

i believe that’s true for this physical body ,
but i’m forced to believe this spirit of consciousness will continue to experience itself .
i am never not truly experiencing myself .
even when my brain shuts off .

this true spirit of myself has only gotten used to this vessel .
it knows it lives in recess ,
constantly anticipating the next adventure , and discovery .
yet convinces this vessel it is the entirety ,
like a horse being led by a knight .

the knight looks into the world ,
while the animal looks toward the knight .
i can only see what is shown to me ,
yet moments of divinity remove my reins ,
letting me look through the eyes of this spirit .

this well known stranger reminds me of a higher awareness ,
feelings of higher conscious desire ,
higher sensation ,
related to the warmth i feel when you touch my skin .`,
      },
      {
        pageNumber: "039",
        subtitle: "SECTION II",
        body: `I was sitting on a hill ,
eating from the ground ,
enjoying the day
as I was showed to .
being confident in my faith and what’s to come,
as I was taught to ,

when suddenly the spirit of life that drives all things organic
appeared before me
and spoke words i understood only in this moment .

an ancient language used in the creation of this time . 

as the creation of time myself ,
i understood these words never before spoken until this moment .

This spirit proceeded to ask :

“What part of this chaos seems orderly?
What comparison can you make to the only experience you’ve ever known?
What knowledge of your history is more important than what I can teach you now?
Why does your life work seem meaningless in my presence?
What moments have I given you for you to consciously love that you’ve taken for granted?
What archetypical characters have I casted in your story which you taught yourself to hate?
What experiences are exempt from deserving love, to be thankful for the model you now have the clarity to embody or reject?
What societal structures have been forced upon you to believe, and which ones have forced you into obeying as of this moment?”

without a breath the spirit proceeded to answer these questions
in the same order they were given :

:Everything primitively organic grows toward light, and is guided by it. Life has no place to assume control of this process. A flower grows only because the bird dropped its seed in discovery of a higher desire.

All of purpose stems from crossroads. Crossroads in place simply by existing, and there is teachings whether that life exists in pleasure or suffering.

Why do you assume there is more to your experience than this? Why do you waste the day fantasizing fiction of your knowledge?

As of this moment no eternal bliss will be given to you or any one you know. Hear what I tell you. Feel what I am touch upon you. No past interpretation of yours can overturn this moment I teach you. The realization of this reality horrifies your man made beliefs. Throw your concept of a work-to-win grounds pass away.

You are enabled now for your inspiration. No steps of achievement are required to chase the pleasure and desire I instill within you. Realize your act of entertainment will never remove the required love towards the bird. The crossroads have summoned your stamp life in this moment forever.

Be thankful for what has experienced you, and what is experiencing you now, and go have a conscious moment of love-filled gratitude so that you will not regret your decisions when you no longer have the option, when the option has left the only reality you know.

Understood that familiarity with this reality does not always reveal pleasure. Brutality of this world teaches the same weight as the attraction of this world. Those who turn you sick at once glance have taught you through their acts of wickedness how not to live, and those who have shined a light on your shadows to reveal the love you always harnessed have taught you through acts of goodness how to live embodying this light.

Know that both acts have sourced from my inspiration, and I am the alchemist who refines all things into good, growth, and evolution in this march through time. Be thankful for the clarity in observing an action. Pay attention to your feelings which strengthen discernment.

Do not dwell or anger toward the wicked indoctrinations of your life. You are wasting time and giving strength to what you should forget. Although your subconscious may have been following those guidelines; it is thanks and appreciation for those wicked guidelines that have enabled this lesson, and for our gazes to meet in this moment.”`,
      },
      {
        pageNumber: "040",
        heading: "SECTiON III - DANCE , THEATER , LiGHTS ON / OFF",
      },
      {
        pageNumber: "041",
        subtitle: "SECTION III",
        body: `allow life to become no resistance , only reflection .
allow the part of you with no language to speak .
all the fun , freedom , danger , and art are not distractions , but guidance .
not just proof of life , but self .
the desperation for explanation paralyzes the writings of this moments record .
uncover the script to this movie by acting now , and loving this final cut . 
every moment , every vision , every risk , every connection , 
is devotion to this explanation :
meaning flowing out of you , as you .`,
      },
      {
        pageNumber: "042",
        subtitle: "SECTION III",
        body: `in a world absent of light , 
the light becomes a spectacle of inspiration . 
this world , thriving in its own style , 
may embrace or reject this new presence . 
yet either way , 
it is transformed .
in a world with abundance of light , 
expectation and conformity arise , 
a normative model abandoning contrast . 
until a darkness arrives ,
and the light is forced to observe this variant of life .
in this external reflection ,
an internal inspiration is found , once again .`,
      },
      {
        pageNumber: "043",
        subtitle: "SECTION III",
        body: `live hot to heal ,
or cold to refresh .
living lukewarm is passion leads no where .`,
      },
      {
        pageNumber: "044",
        subtitle: "SECTION III",
        body: `dance to the song that never ends .
a dance that reflects light into a million eyes .`,
      },
      {
        pageNumber: "045",
        subtitle: "SECTION III",
        body: `i love this moment .
those who witness this see an achievement at most .
for me , i feel the journey becoming this moment .
this second , i cherish my becoming more than ever , 
and the next second i move on , 
already desiring another moment .

these journeys paint organic art .
i miss the gallery showings 
by being too busy reaching for fulfillment .

the angels deliver presents.
they watch me tear through wrapping paper inked in my favorite colors ,
too fast to notice how perfect the paper was in my hands .

revealing a gift once dreamed 
by someone i am yet to be .

if i remain conscious , i cry ,
knowing their intention as mine .

mono no aware .

if i’m blissfully ignorant , then i’ll smile ,
and the angels watch me in joy , 
as a mother on christmas morning watches her child 
holding a surprise , unaware of the cost .

later , 
i’ll remember that gift becoming my moment ,
and i cry .

anagnorisis .`,
      },
      {
        pageNumber: "046",
        subtitle: "SECTION III",
        body: `less thinking more dancing .`,
      },
      {
        pageNumber: "047",
        subtitle: "SECTION III",
        body: `if we only love , this dance has no back steps .`,
      },
      {
        pageNumber: "047",
        subtitle: "SECTION III",
        body: `see light speak light .`,
      },
      {
        pageNumber: "048",
        subtitle: "SECTION III",
        body: `when you step toward desire in the unknown . 
i am closer than ever . 
let us dance .`,
      },
      {
        pageNumber: "049",
        subtitle: "SECTION III",
        body: `the building doesn't make the theater . 
the dance creates it . 
only when the dance is reborn will the theater return .`,
      },
      {
        pageNumber: "050",
        subtitle: "SECTION III",
        body: `we have assembled inside this ancient and insane theater .
to propagate our lust for light .
oh great creator of being .
grant us one more hour 
to perform our art and perfect our lives .`,
      },
      {
        pageNumber: "051",
        subtitle: "SECTION III",
        body: `this light speaks in an ancient language .
words never spoken before this moment .`,
      },
      {
        pageNumber: "052",
        subtitle: "SECTION III",
        body: `i can only see the shadow of who i am . 
        you can only see the shadow of who i am . 
        the shadow dancing itself to sleep .`,
      },
      {
        pageNumber: "053",
        subtitle: "SECTION III",
        body: `i lay here ,
looking to the stars .
the light i see is surrounded by darkness .
i see more darkness than light .
why should i call what i see a star , 
and not dark ?

i realize this thought is born in light .
i would feel no inspiration only seeing dark .
the light is the reason for this reflection .
its existence has shaped this embodiment .

whether i hate the star ,
or whether i love the star , now , 
i have decided how i want to act .
i’ve decided how i want to be seen .
how i want to be embodied ,
when surrounded by darkness .`,
      },
      {
        pageNumber: "054",
        subtitle: "SECTION III",
        body: `a world of abundance .
freedom to see within a light , 
the obvious sun . self evidently awoken .
living in that light , 
confirming it in each other .
billions of small flames become one blaze . 
a renaissance .`,
      },
      {
        pageNumber: "055",
        subtitle: "SECTION III",
        body: `a play with no finale .
a dance that never stops .
a creator that never dies .
a melody that never resolves .
a flower that keeps blooming .
a question with no answer .
a voice that can't be recorded .
a shadow that never leaves .
a puzzle with no boundaries .
a ball of yarn with no center .
a river with no ending .
a dream that never wakes .
a journey that leads no where .
a movie thats always beginning .
light that always shines .
darkness that consumes all .
behind the scenes of a live stream .
a script that only makes sense to me . 
beautifully complex life you are .`,
      },
      {
        pageNumber: "056",
        heading: "SECTiON IV - METAMORPHOSiS , FAMiLY , EMOTION",
      },
      {
        pageNumber: "057",
        subtitle: "SECTION IV",
        body: `metamorphosis :
transfiguration of light .
the cocoon is not dark .
i do not wait for the singularity ,
i am ,
channeling chaos for my own evolution .`,
      },
      {
        pageNumber: "058",
        subtitle: "SECTION IV",
        body: `i’m being devoured by a creators spirit .
i am succumbing to my chaos . 
which means stillness feels like death . 
happiness is overwhelming . 
love is constant—but never fully expressed properly . 
comparison is impossible . 
creation is inevitably perfect . 
intimacy is now . `,
      },
      {
        pageNumber: "059",
        subtitle: "SECTION IV",
        body: `my brothers and sisters—we aren’t lovers . 
i come from family and will return to it . 
maybe then i will be enabled to express this spirit to you .
or maybe all this is already the product of that expression . 

expectation is no longer a part of me . 
what more is there than the experience of my creation , evolution , my family ? 
i don’t feel like i want anything more . 

if you want to understand art :
living the answer is easier than seeking it . 

may my intimacy remain not in possession , but in presence . 
my happiness not as a goal , but a byproduct of surrender .`,
      },
      {
        pageNumber: "060",
        subtitle: "SECTION IV",
        body: `growth reveals itself through its relationship in light .`,
      },
      {
        pageNumber: "061",
        subtitle: "SECTION IV",
        body: `a castle fire starts with one flame .`,
      },
      {
        pageNumber: "062",
        subtitle: "SECTION IV",
        body: `join the wave .
join the blaze .`,
      },
      {
        pageNumber: "063",
        subtitle: "SECTION IV",
        body: `go deeper in yourself ,
go find what you really want and what you’re about .`,
      },
      {
        pageNumber: "064",
        subtitle: "SECTION IV",
        body: `i’m so happy i could meet you here .`,
      },
      {
        pageNumber: "065",
        subtitle: "SECTION IV",
        body: `i can’t believe my mind , how do i love these people so much .`,
      },
      {
        pageNumber: "066",
        subtitle: "SECTION IV",
        body: `out of every room i could choose to be in , 
        i have started loving the one with you the most . 
        the one we’re in right now .`,
      },
      {
        pageNumber: "067",
        subtitle: "SECTION IV",
        body: `thankful for what holds meaning to me . 
        everything undergone semiosis required a significant event to charge , 
        what was once an empty vessel , 
        into a symbol and vision of the future .`,
      },
      {
        pageNumber: "068",
        subtitle: "SECTION IV",
        body: `spirit influence this stone .`,
      },
      {
        pageNumber: "069",
        subtitle: "SECTION IV",
        body: `crazy is a deliberate act . 
        chaos is a natural state . 
        the energy of life is chaos . 
        we are perfectly insane . 
        we charge our life with meaning from inspiration . 
        the product is significant to the timeline .`,
      },
      {
        pageNumber: "070",
        subtitle: "SECTION IV",
        body: `living in full truth of oneself is the highest form of worship. 
        where belief becomes visible , 
        outlining reality as the only divine manifestation possible .`,
      },
      {
        pageNumber: "071",
        subtitle: "SECTION IV",
        body: `divinity in the script that only makes sense to me . `,
      },
      {
        pageNumber: "072",
        subtitle: "SECTION IV",
        body: `choose life .
you can’t compare this to anything else .
this is all you’ve ever known .
you wouldn’t rather any other state of being .
you can learn from this experience, and change however you want .
you can do it as early as right now . `,
      },
      {
        pageNumber: "073",
        subtitle: "SECTION IV",
        body: `the world alters with each rotation .
what is new is not the world . 
it is the one who observes it .
you are the repetition and the change .`,
      },
      {
        pageNumber: "074",
        subtitle: "SECTION IV",
        body: `we give no attention to the noise .`,
      },
      {
        pageNumber: "075",
        heading: "SECTiON V - OUR TiME TOGETHER",
      },
      {
        pageNumber: "076",
        subtitle: "SECTION IV",
        body: `really what i want: 
        for you to see me , 
        and just to walk up to me . 
        walk up to me , 
        and don't touch me ha ha ha ha ha ha , 
        but say hey NEP2YN . 
        hey NEP2YN . 
        hey Casey Crossman , 
        you can say that , 
        say that , 
        and then i can grab your hand , 
        and then we can feel this time . 
        cause the time is physical now . 
        time is physical now , 
        and the time is right now , 
        and all the geometry that could possibly be ; 
        is forming your face . 
        your face ? 
        and its forming my face , 
        my face ? 
        who am i ? 
        who am i for this timeline to create ? 
        who am i for this new moment that we could share ? 
        we're sharing this right now , 
        right now , 
        and then we walk away . 
        We wont ever see again . 
        oh but you feel the EMOTION forever , 
        you feel it when we sleep you feel it all the time . 
        when we see a new project . 
        when we apply for a new job . 
        when we oh . 
        when we see a new song , 
        a new aspect of art , 
        maybe its all just a performance , 
        but the performance that i can only give , 
        i can only give it . 
        i can only give it , 
        and you can take with it for what you want . 
        theres no way its only been a few seconds , 
        cause what we shared was infinite .`,
      },
  ];
  
  export default book1Pages;